import React from 'react';
import { withRouter } from 'react-router';
import {
  SidebarBtn,
  Navbar,
  Nav,
  NavItem,
  Icon,
  Grid,
  Row,
  Col,
} from '@sketchpixy/rubix';

import { logout } from '../api/api';

class Brand extends React.Component {
  render() {
    return (
      <Navbar.Header {...this.props}>
        <Navbar.Brand tabIndex="-1">
          <a href="#">
            <img
              src="https://content.neofect.com/assets/images/neofect-ci.png"
              alt="neofect"
              width="168"
              height="31"
            />
          </a>
        </Navbar.Brand>
      </Navbar.Header>
    );
  }
}

@withRouter
class HeaderNavigation extends React.Component {
  constructor(props) {
    super(props);
  }

  handleLogout = () => {
    logout((err) => {
      if (err) {
        console.error(err);
      } else {
        localStorage.clear();
        this.props.router.push('/login');
      }
    });
  };

  render() {
    return (
      <Nav pullRight>
        <Nav>
          <NavItem className="logout" href="#" onClick={this.handleLogout}>
            <Icon bundle="fontello" glyph="off-1" />
          </NavItem>
        </Nav>
      </Nav>
    );
  }
}

export default class Header extends React.Component {
  render() {
    return (
      <Grid id="navbar" {...this.props}>
        <Row>
          <Col xs={12}>
            <Navbar fixedTop fluid id="rubix-nav-header">
              <Row>
                <Col xs={3} visible="xs">
                  <SidebarBtn />
                </Col>
                <Col xs={6} sm={4}>
                  <Brand />
                </Col>
                <Col xs={3} sm={8} collapseRight className="text-right">
                  <HeaderNavigation />
                </Col>
              </Row>
            </Navbar>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/header.js